import { Popover } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import QuickBooksModal from './quickbooks-modal/QuickBooksModal';
import { pushEventInfo } from '../../../utils/analytics';
var paragraph1 = function () { return (React.createElement("span", null, "Sync your Home Depot transactions with QuickBooks Online and QuickBooks Desktop.")); };
var paragraph2 = function () { return (React.createElement("p", null,
    React.createElement("b", null, "QuickBooks Online"),
    " ",
    React.createElement("br", null),
    " Export summary and detailed transaction data for all of your Home Depot purchases. These transactions will include \"Home Depot- QuickBooks Purchases\" as their associated credit card. ",
    React.createElement("b", null, "Note"),
    " that the export feature only supports exports of up to 390 transactions at a time.")); };
var paragraph3 = function () { return (React.createElement("p", null,
    React.createElement("b", null, "QuickBooks Desktop"),
    " ",
    React.createElement("br", null),
    " Exporting to QuickBooks Desktop involves a couple more steps. The tutorial in the next section will walk through what those include. As with QuickBooks Online, your transactions will export with The Home Depot as the vendor and \"Home Depot QuickBooks Purchases\" as their associated credit card.")); };
export var QuickBooksButton = function (_a) {
    var request = _a.request, setAlertState = _a.setAlertState;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState(false), openModal = _c[0], setOpenModal = _c[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    return (React.createElement("div", { className: "sui-flex sui-items-center" },
        React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/QBIcon.svg", alt: "Quick Books Icon", width: "25px", height: "25px" }),
        React.createElement("button", { "data-testid": "quickbooks-export-button", type: "button", className: "sui-underline", onClick: function () {
                pushEventInfo({
                    category: { primaryCategory: 'button submission' },
                    eventInfo: { eventName: 'my account settings' },
                    myAccount: { settings: 'purchase history: quickbooks export' },
                });
                setOpenModal(true);
            } }, "Quick Books Exports"),
        React.createElement("button", { "data-testid": "quickbooks-export-info-button", type: "button", onClick: handleClick, style: { paddingTop: 5, paddingLeft: 5 } },
            React.createElement(InfoFilled, { color: "subtle", size: "small" }),
            ' '),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, placement: "bottom", title: "Add Purchases to QuickBooks", style: { zIndex: 1000 } },
            React.createElement("div", { className: "quickbooks-export-info", "data-testid": "quickbooksExportInfo" },
                React.createElement("div", { className: "quickbooks-export-info__paragraph" },
                    paragraph1(),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    paragraph2(),
                    React.createElement("br", null),
                    paragraph3()))),
        React.createElement(QuickBooksModal, { openModal: openModal, setOpenModal: setOpenModal, request: request, setAlertState: setAlertState })));
};
